import { render } from "./person-real-update.vue?vue&type=template&id=0d42f440"
import script from "./person-real-update.vue?vue&type=script&lang=js"
export * from "./person-real-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__